<template>
  <div
    v-if="isImpersonating"
    class="impersonation-banner-bar"
    role="region"
    aria-label="Impersonation session"
  >
    <div class="impersonation-banner-inner">
      <span>
        Viewing as <span class="fs-exclude ib-name">{{ userName }}</span>
      </span>
      <span aria-hidden="true">&mdash;</span>
      <span>
        <span class="sr-only">Session expires in </span>
        <span>{{ countdown }}</span>
      </span>
      <span aria-hidden="true">&mdash;</span>
      <a :href="signOutUrl" class="ib-exit">Exit</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { goalbookUrls } from '@/links'

export default {
  name: 'ImpersonationBanner',
  data() {
    return {
      now: Date.now(),
      ticker: null,
      signOutUrl: goalbookUrls.signOut,
    }
  },
  computed: {
    ...mapGetters('user', ['isImpersonating', 'userName', 'impersonationExpiresAt']),
    secondsRemaining() {
      if (!this.impersonationExpiresAt) {
        return 0
      }
      const millisRemaining = new Date(this.impersonationExpiresAt).getTime() - this.now
      return Math.max(0, Math.floor(millisRemaining / 1000))
    },
    countdown() {
      const minutes = Math.floor(this.secondsRemaining / 60)
      const seconds = this.secondsRemaining % 60
      return `${minutes}:${String(seconds).padStart(2, '0')}`
    },
  },
  mounted() {
    this.ticker = setInterval(() => {
      this.now = Date.now()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.ticker)
  },
}
</script>

<style scoped lang="less">
@import '~@/variables.less';

.impersonation-banner-bar {
  width: 100%;
  background: @gb_orange;
  color: @gray-dark;
  font-size: 14px;
  line-height: 1.4;
}

.impersonation-banner-inner {
  width: 100%;
  box-sizing: border-box;
  max-width: 1170px;
  margin: 0 auto;
  padding: 8px 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 2px 8px;
  text-align: center;
}

.ib-name {
  font-weight: 700;
}

.ib-exit {
  background: transparent;
  border: 0;
  padding: 0;
  color: @gray-dark;
  font-weight: 600;
  text-decoration: underline;
  cursor: pointer;
}

.ib-exit:focus-visible {
  outline: 2px solid @gray-dark;
  outline-offset: 2px;
}
</style>
